import { useDispatch, useSelector } from "react-redux"
import { backdropActions } from "../../../../../store/backdrop-slice"
import { userActions } from "../../../../../store/user-slice"
import Modal from "../../../../Modal"
import { Fragment, useEffect, useReducer, useState } from "react"
import useFilter from "../../../../../hook/useFilter"
import useVariable from "../../../../../hook/useVariable"
import Pagination from "./Pagination"
import { Link } from "react-router-dom"
import InfoIcon from "../../../../InfoIcon"
import { faArrowDownAZ } from "@fortawesome/free-solid-svg-icons"
import ResortComponent from "./ResortItems"
import parse from 'html-react-parser'

const Filter = (props) => {

    let defaultUserCount = useSelector((state) => state.user.filterUserCount)
    let pagination = useSelector((state) => state.user.pagination)

    let sliceFilters = useSelector(state => state.user.filter)
    let sliceActions = userActions
    let sliceItems = useSelector(state => state.user.users)
    const [isMount, setIsMount] = useState(false)

    const { children } = props


    let dispatch = useDispatch()

    const { doFilter } = useFilter()
    const { variableValue } = useVariable()

    const [paginationItems, setPaginationItems] = useState([])

    useEffect(() => {
        let items = []
        if (pagination) {
            pagination.map((item, key) => {

                items.push(<Pagination key={key} users={item} index={key} />)
            })
        }

        setPaginationItems(items)
    }, [pagination])


    let filter = useSelector((state) => state.user.filter)

    useEffect(() => {

        if (!isMount) {
            setIsMount(true)
            return
        }


        doFilter(sliceFilters, sliceItems, sliceActions)
    }, [filter])




    const [showFilter, setShowFilter] = useState(false)


    return <div className="p-3" >
        <Link className="btn btn-secondary bgnt mb-2" to='/admin/user' >New User</Link>
        <div className="card shadow  bg-white rounded p-3 mb-3" style={{ cursor: 'pointer' }} onClick={() => {
            setShowFilter(!showFilter)
        }}  >

            <InfoIcon icon={faArrowDownAZ} size='xl' />

        </div>
        {showFilter &&
            <Fragment>
                <label>Pagination</label><select name="filterPostCount" defaultValue={filter.pagination} className="mb-2" onChange={(event) => {
                    let value = variableValue(event.target.value)
                    dispatch(userActions.setFilter({
                        key: 'pagination',
                        value
                    }))

                }} >
                    <option value='' >All</option>

                    {
                        defaultUserCount.map((item, key) => {

                            return <option key={key} value={item} >{item}</option>
                        })
                    }
                </select>

                <ResortComponent type='id' name='ID' />
                <ResortComponent type='username' name='Username' />
                <ResortComponent type='email' name='Email' />
                <ResortComponent type='is_admin' name='IsAdmin' />
                <ResortComponent type='status' name='Status' />
                <ResortComponent type='activated' name='Activated' />
                <ResortComponent type='created_on' name='CreatedOn' />

            </Fragment>}
        <input type="text" name="filter-email-username" className="mb-2" defaultValue={filter.search} placeholder="email or username" onInput={(event) => {
            let value = variableValue(event.target.value)

            dispatch(userActions.setFilter({
                key: 'search',
                value
            }))


        }} />

        {children}

        <div className="pagination-container">{paginationItems}</div>
        
    </div>
}


export default Filter